import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { Users, AlertTriangle, Megaphone, Building2 } from "lucide-react";
import { toast } from "sonner";

export default function AssociationDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/association/stats").then((r) => setStats(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);

  return (
    <div className="min-h-full">
      <PageHeader eyebrow="Tableau de bord" title="Espace Association / ONG" sub="Pilotez votre organisation, vos adhérents et vos publications." />
      <div className="p-6 lg:p-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 border border-[#0A0A0A]" data-testid="association-kpis">
          <Stat label="Adhérents" value={stats?.nb_adherents ?? "—"} icon={Building2} testid="kpi-adherents" highlight />
          <Stat label="Plaintes totales" value={stats?.nb_plaintes_total ?? "—"} icon={AlertTriangle} testid="kpi-plaintes-total" />
          <Stat label="Plaintes ouvertes" value={stats?.nb_plaintes_open ?? "—"} icon={AlertTriangle} testid="kpi-plaintes-open" warn />
          <Stat label="Actualités publiées" value={stats?.nb_actualites ?? "—"} icon={Megaphone} testid="kpi-actualites" />
        </div>

        <div className="mt-8 bg-white border border-[#DEE2E6] p-6">
          <div className="text-xs uppercase tracking-[0.25em] font-bold mb-3">À propos de votre espace</div>
          <p className="text-sm text-[#495057] leading-relaxed">
            Votre espace association / ONG vous permet de :
          </p>
          <ul className="mt-3 space-y-1 text-sm text-[#0A0A0A]">
            <li>• Affilier des entreprises à votre organisation (onglet <b>Adhérents</b>)</li>
            <li>• Gérer les plaintes anonymes ou nominatives des salariés des entreprises adhérentes</li>
            <li>• Publier des actualités visibles par les salariés des entreprises adhérentes</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, icon: Icon, testid, highlight, warn }) {
  return (
    <div data-testid={testid} className={`p-5 lg:p-6 border-r border-[#0A0A0A] last:border-r-0 ${highlight ? "bg-[#002FA7] text-white" : warn ? "bg-[#FEF2F2]" : "bg-white"}`}>
      <div className="flex items-center gap-2">
        <Icon className={`h-3.5 w-3.5 ${highlight ? "text-[#FFD700]" : warn ? "text-[#E60000]" : "text-[#002FA7]"}`} />
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold opacity-70">{label}</div>
      </div>
      <div className="font-display text-3xl lg:text-4xl font-black tracking-tighter mt-2">{value}</div>
    </div>
  );
}
